import { v4 as uuid4 } from 'uuid';

export interface IMessage {
    type: string;
}

export interface ICreate {
    type: string | 'audio' | 'video' | 'image' | 'text';
    file: string;
    size?: string;
}

export interface IMouse {
    client: {
        x: number;
        y: number;
    };
    screen: {
        x: number;
        y: number;
    };
    page: {
        x: number;
        y: number;
    };
    movement: {
        x: number;
        y: number;
    };
}

export const INIT = 'PLUGIN.INIT';
export const CREATE = 'PLUGIN.CREATE';
export const READ = 'PLUGIN.READ';
export const UPDATE = 'PLUGIN.UPDATE';
export const DELETE = 'PLUGIN.DELETE';
export const CALLBACK = 'PLUGIN.CALLBACK';
export const DRAG_START = 'PLUGIN.DRAG_START';
export const DRAG_END = 'PLUGIN.DRAG_END';

export class InitMessage implements IMessage {
    readonly type = INIT;
    constructor(public readonly clientId: string, public readonly frameId: string) {}
}

export class SetCreateMessage implements IMessage {
    readonly type = CREATE;
    requestId: string;
    payload: ICreate[];

    constructor(payload: ICreate[]) {
        const uid = uuid4();
        this.requestId = uid;
        this.payload = payload;
    }
}

export class SetDragStartMessage implements IMessage {
    readonly type = DRAG_START;
    requestId: string;
    payload: ICreate[];

    constructor(payload: ICreate[]) {
        const uid = uuid4();
        this.requestId = uid;
        this.payload = payload;
    }
}

export class SetDragEndMessage implements IMessage {
    readonly type = DRAG_END;
    requestId: string;
    mouse: IMouse;

    constructor(mouse: IMouse) {
        const uid = uuid4();
        this.requestId = uid;
        this.mouse = mouse;
    }
}

export class CallbackMessage implements IMessage {
    readonly type = CALLBACK;
    constructor(public readonly requestId: string, public readonly data: any) {}
}
